var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"message-wrapper"},[(_vm.isMsgHead)?_c('div',{staticClass:"msg-head"},[_vm._t("msg_head")],2):_vm._e(),(_vm.previewMode)?_c('div',{staticClass:"msg msg-body f-14",domProps:{"innerHTML":_vm._s(_vm.getTextMsgPreview)}}):_c('div',{staticClass:"msg msg-body f-14",domProps:{"innerHTML":_vm._s(_vm.getTextMsg)}})])
}
var staticRenderFns = []

export { render, staticRenderFns }